import React from 'react';
import { Link } from 'react-router-dom';
import { TrustBadges } from '../components/TrustBadges';
import { StickyCTA } from '../components/StickyCTA';
import { ServicesAccordion } from '../components/ServicesAccordion';
import { WashingMachineIcon, RefrigeratorIcon, CookingPotIcon, UtensilsIcon, WindIcon, CheckIcon, ZapIcon, ShieldCheckIcon, PoundSterlingIcon, LockIcon, MapPinIcon } from 'lucide-react';
export function Home() {
  const appliances = [{
    icon: WashingMachineIcon,
    name: 'Washing Machines',
    desc: 'Expert diagnostics and repairs'
  }, {
    icon: RefrigeratorIcon,
    name: 'Fridges & Freezers',
    desc: 'Temperature control and maintenance'
  }, {
    icon: CookingPotIcon,
    name: 'Cookers & Ovens',
    desc: 'Element replacement and servicing'
  }, {
    icon: UtensilsIcon,
    name: 'Dishwashers',
    desc: 'Pump and drainage repairs'
  }, {
    icon: WindIcon,
    name: 'Tumble Dryers',
    desc: 'Heating element diagnostics'
  }];
  const uspCards = [{
    icon: ZapIcon,
    title: 'Fast Response',
    desc: 'Same-day and emergency callouts available'
  }, {
    icon: ShieldCheckIcon,
    title: 'Qualified Engineers',
    desc: 'Experienced, vetted professionals'
  }, {
    icon: PoundSterlingIcon,
    title: 'Transparent Pricing',
    desc: 'Clear quotes with no hidden fees'
  }, {
    icon: LockIcon,
    title: 'Secure Payments',
    desc: 'Safe, encrypted payment processing'
  }];
  const process = [{
    step: 'Book',
    desc: 'Schedule your repair online or by phone'
  }, {
    step: 'Diagnose',
    desc: 'Engineer inspects and assesses the fault'
  }, {
    step: 'Repair',
    desc: 'Professional repair completed'
  }, {
    step: 'Test',
    desc: 'Appliance tested and verified working'
  }];
  const servicePackages = [{
    title: 'Engineer Callout & Diagnostics',
    price: '£99',
    description: 'Fixed visit to assess fault and quote for repairs. Parts approved before fitting.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pSjcZvwzYPPvsjKTC7L8b3/12._Washing_Machine.png',
    alt: "Engineer diagnosing washing machine in customer's kitchen – professional diagnostics",
    stripeLink: 'https://buy.stripe.com/5kQdR24sF1Ob0Bddl25sA00'
  }, {
    title: 'One-Year Repair Service (TV + Set-Top Box)',
    price: '£120',
    description: 'Fast response for TV faults and connection issues. Engineer visits scheduled promptly. Friendly support every step of the way.',
    image: 'https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=800&h=600&fit=crop',
    alt: 'Family watching TV in comfortable living room – entertainment system repair service',
    stripeLink: 'https://buy.stripe.com/00w4gs9MZgJ53Np3Ks5sA01'
  }, {
    title: 'Two-Year Repair Service (1 Appliance)',
    price: '£150',
    description: 'Extended engineer support for one appliance. Diagnostics, repairs and standard parts (when available). Priority booking for the full term.',
    image: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&h=600&fit=crop',
    alt: 'Modern kitchen with fridge and oven – appliance repair and maintenance service',
    stripeLink: 'https://buy.stripe.com/4gM14g0cp3Wj83Ffta5sA02'
  }];
  const testimonials = [{
    quote: 'Brilliant same-day response.',
    author: 'J. Turner'
  }, {
    quote: 'Clear pricing and tidy work.',
    author: 'A. Patel'
  }, {
    quote: 'Fixed our washer first visit.',
    author: 'S. Bennett'
  }];
  return <div className="w-full pb-24" data-id="element-351">
      <section className="relative bg-gradient-to-br from-teal-600 to-teal-700 text-white py-20" data-id="element-352">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-353">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-354">
            <div data-id="element-355">
              <h1 className="text-5xl font-bold mb-6" data-id="element-356">
                Fast, Reliable Appliance Repairs Across the UK
              </h1>
              <p className="text-xl text-teal-50 mb-8" data-id="element-357">
                Qualified engineers. Clear pricing. Quick bookings.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-358">
                <Link to="/contact" className="bg-white text-teal-700 px-8 py-3 rounded-lg font-semibold hover:bg-teal-50 transition" data-id="element-359">
                  Book a Repair
                </Link>
                <a href="tel:08000554969" className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-teal-700 transition" data-id="element-360">
                  Call 0800 055 4969
                </a>
              </div>
            </div>
            <div className="relative h-96 rounded-lg overflow-hidden shadow-2xl" data-id="element-361">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tnnqNGxZHPotrffj76B5ut/5.png" alt="Couple in modern laundry room with washing machines – professional appliance repair service" className="w-full h-full object-cover" data-id="element-362" />
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-363">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-364">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-365">
            {uspCards.map((card, index) => <div key={index} className="bg-slate-50 p-6 rounded-xl border border-slate-200 hover:shadow-lg transition text-center" data-id="element-366">
                <card.icon className="w-12 h-12 text-teal-600 mx-auto mb-4" data-id="element-367" />
                <h3 className="font-semibold text-slate-800 mb-2 text-lg" data-id="element-368">
                  {card.title}
                </h3>
                <p className="text-sm text-slate-600" data-id="element-369">{card.desc}</p>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 bg-slate-50" data-id="element-370">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-371">
          <h2 className="text-3xl font-bold text-center text-slate-800 mb-12" data-id="element-372">
            How It Works
          </h2>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-373">
            {process.map((item, index) => <div key={index} className="text-center" data-id="element-374">
                <div className="bg-teal-600 text-white w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4" data-id="element-375">
                  {index + 1}
                </div>
                <h3 className="font-semibold text-slate-800 mb-2" data-id="element-376">
                  {item.step}
                </h3>
                <p className="text-sm text-slate-600" data-id="element-377">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-378">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-379">
          <h2 className="text-3xl font-bold text-center text-slate-800 mb-4" data-id="element-380">
            Service Packages
          </h2>
          <p className="text-center text-slate-600 mb-12 max-w-2xl mx-auto" data-id="element-381">
            Choose the right service for your needs with transparent pricing and
            secure online payment
          </p>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-382">
            {servicePackages.map((pkg, index) => <div key={index} className="bg-slate-50 rounded-xl shadow-md overflow-hidden hover:shadow-xl transition border border-slate-200" data-id="element-383">
                <div className="relative h-64" data-id="element-384">
                  <img src={pkg.image} alt={pkg.alt} className="w-full h-full object-cover" data-id="element-385" />
                </div>
                <div className="p-6" data-id="element-386">
                  <h3 className="text-2xl font-bold text-slate-800 mb-2" data-id="element-387">
                    {pkg.title}
                  </h3>
                  <div className="text-3xl font-bold text-teal-600 mb-4" data-id="element-388">
                    {pkg.price}
                  </div>
                  <p className="text-slate-600 mb-6" data-id="element-389">{pkg.description}</p>
                  <a href={pkg.stripeLink} target="_blank" rel="noopener noreferrer" className="block w-full bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition text-center" data-id="element-390">
                    Pay Securely (Stripe)
                  </a>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 bg-slate-50" data-id="element-391">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-392">
          <h2 className="text-3xl font-bold text-center text-slate-800 mb-4" data-id="element-393">
            Our Repair Services
          </h2>
          <p className="text-center text-slate-600 mb-12 max-w-2xl mx-auto" data-id="element-394">
            Professional diagnostics, repairs, and maintenance for all major
            household appliances
          </p>
          <div className="max-w-3xl mx-auto" data-id="element-395">
            <ServicesAccordion data-id="element-396" />
          </div>
          <div className="text-center mt-8" data-id="element-397">
            <Link to="/services" className="inline-block text-teal-600 font-semibold hover:text-teal-700" data-id="element-398">
              View all repair services →
            </Link>
          </div>
        </div>
      </section>
      <section className="py-16 bg-slate-50" data-id="element-399">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-400">
          <h2 className="text-3xl font-bold text-center text-slate-800 mb-12" data-id="element-401">
            Appliances We Repair
          </h2>
          <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-402">
            {appliances.map((appliance, index) => <div key={index} className="bg-white p-6 rounded-xl hover:shadow-lg transition text-center border border-slate-200" data-id="element-403">
                <appliance.icon className="w-12 h-12 text-teal-600 mx-auto mb-4" data-id="element-404" />
                <h3 className="font-semibold text-slate-800 mb-2" data-id="element-405">
                  {appliance.name}
                </h3>
                <p className="text-sm text-slate-600" data-id="element-406">{appliance.desc}</p>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-407">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-408">
          <h2 className="text-3xl font-bold text-center text-slate-800 mb-12" data-id="element-409">
            What Our Customers Say
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-410">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-xl border border-slate-200" data-id="element-411">
                <p className="text-slate-700 italic mb-4" data-id="element-412">
                  "{testimonial.quote}"
                </p>
                <p className="text-sm text-slate-600 font-semibold" data-id="element-413">
                  — {testimonial.author}
                </p>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 bg-teal-600 text-white" data-id="element-414">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-415">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-416">
            <MapPinIcon className="w-6 h-6" data-id="element-417" />
            <h2 className="text-2xl font-bold" data-id="element-418">UK Mainland Coverage</h2>
          </div>
          <p className="text-center text-teal-50 max-w-2xl mx-auto" data-id="element-419">
            We provide professional appliance repair services across England,
            Scotland, and Wales. Based in Portsmouth, we serve Hampshire,
            Sussex, Surrey, and surrounding counties with same-day emergency
            callouts available.
          </p>
        </div>
      </section>
      <StickyCTA data-id="element-420" />
    </div>;
}